// extracted by mini-css-extract-plugin
export default {"main_input":"styles_main_input__rL4FI","error":"styles_error__i0MQ2"};